module.exports = __webpack_public_path__ + "img/senile_pic.d52b5257.png";